import { bindable, bindingMode } from "aurelia-framework";

/**
 * A simple note component.
 *
 * Usage:
 *
 * <k-note textcontent.bind="mymodel" ></k-note>
 */
export class KNoteCustomElement {
  @bindable({ defaultBindingMode: bindingMode.twoWay }) textcontent: string;
}
